import { useState,useEffect } from "react"
import style from "./controlPanel.module.scss"
import axios from "axios"

const MenuVersion = ({ setting, setSetting, region, company }) => {
	const selectBus = row =>{
		setSetting({
			...setting,
			bus:row,
		})
	}	

	const [rows, setRows] = useState([]);
	const [totPage, setTotPage] = useState(1);

	const [Companys, setCompanys] = useState([])

	useEffect(() => {
		async function getTotalPage() {
			await getcompanylist();
		}
		getTotalPage();

	}, []);	

	useEffect(() => {
		if(setting && setting.buschg ) {
			getcompanylist();
			
			setSetting({
				...setting,
				buschg : null,
			})
		}
	}, [setting && setting.buschg? setting.buschg:null]);	

	const getcompanylist = async () => {
		try {
			const resp = await axios.get( `${process.env.REACT_APP_PUBLIC_API_URL}/businfo`,{
				params: {
					region: region,
					company: company,
				},
			});
			if(resp.data.data){
				setCompanys(resp.data.data)
			}
			else{
				//setMsg(resp.data.message);
			}
		}catch (err) {
			alert(err);
		}
	};	


	function CompanyRow({row}) {
		return (
			<div key={row.id}>
				<button style={{marginLeft:'10px',width:'120px'}} onClick={() => selectBus(row)}>{row.led} {row.busno} {row.dir}</button>
				<button style={{marginLeft:'10px',width:'120px'}} onClick={() => selectBus(row)}>{row.busid}</button>
			</div>		
		);
	};			

	return <>
		<div
			className={style.controlPanelInfo}
			style={{overflow: 'scroll', height:'500px'}}
		>
		{/* {objects} */}
		{Companys.map((row) => (
			<CompanyRow key={row.id}
				row={row}
			/>
		))}
		</div>
	</>
}

export default MenuVersion
